import Cookies from 'js-cookie';

const handler = ( $ ) => {
	const $popupCross = $( '.popup-alert__cross' );

	if ( $popupCross.length == 0 ) {
		return;
	}

	const clickHandler = function () {
		const $popupAlert = $( this ).parents( '.popup-alert' ),
			cookieName = `wordpress_wom_${ $popupAlert.data(
				'popup-type'
			) }_popup_alert`;

		$popupAlert.fadeOut();
		$( 'body' ).removeClass( 'overflow-hidden' );

		Cookies.set( cookieName, 'disabled', {
			expires: 30,
		} );
	};

	$popupCross.on( 'click', clickHandler );
};

( ( $ ) => {
	$( handler );
} )( jQuery );
